// extracted by mini-css-extract-plugin
export default {"main":"main__wX3Ob","container":"container__Nezog","scrollable":"scrollable__cRTCb","versionSelect":"versionSelect__g1aex"};